module.exports = __webpack_public_path__ + "static/media/do-not-enter.499aeac0.svg";